import { PriceTypesGridView } from '~/components/prices/price-types';
import { PageContainer } from '~/components/page-container';

export function PriceTypes() {
	return (
		<PageContainer>
			<PriceTypesGridView />
		</PageContainer>
	);
}
